import { render, staticRenderFns } from "./CourseCreditTable.vue?vue&type=template&id=11e59d74&scoped=true"
import script from "./CourseCreditTable.vue?vue&type=script&lang=js"
export * from "./CourseCreditTable.vue?vue&type=script&lang=js"
import style0 from "./CourseCreditTable.vue?vue&type=style&index=0&id=11e59d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e59d74",
  null
  
)

export default component.exports